import {UIComponent} from "@/engine/UI/UIComponent.js";
import {mapContext} from "@/context/global.js";
import {UICMapList} from "@/engine/UIcomponents/UICMapList.js";
import {UICollapseList} from "@/engine/UIcomponents/UICollapseList.js";

export class UICMapsPanel extends UIComponent {
    constructor(options) {
        let defOptions = {
            id: "mapsPanel",
            // storage where to store
            contextStorage: null,
            contextStorageKeyCollapse: "mapsPanel",
            contextStorageKeyOrder: "order",
            mapContext: mapContext,
            debug: true,
        }
        super(Object.assign(defOptions, options), null);

        this.layerUICs = {}

        // is used by UICMapList to store an actual maps list
        this.privateWorkspaces = []
        this.publicWorkspaces = []
        this.archiveWorkspaces = []

        let workspaceAdditionalOptionsBuilder = function (ws, opts) {
            return {
                download: ws.publicDownload || ws.mine || ws.shared,
                deletable: ws.mine || ws.shared,
                have_controls: ws.publicDownload || ws.mine || ws.shared || ws.writable,
                preview: ws.getPreview(),
                layerList: this.layersUIC(ws, opts.contextKeySuffix)
            }
        }.bind(this)
        this.mapLists = {
            private: new UICMapList(
                {
                    view: "mapsList",
                    id: "mapsPanel-privateMaps",
                    title: function () {
                        return `My maps (${this.list.length})`
                    },
                    list: this.privateWorkspaces,
                    listBuilder: function () {
                        let sortOrder = []
                        // the list should be ordered, the order is loaded from contextStorage
                        this.mapLists.private.loadContext( function (ctx) {
                            if (ctx instanceof Array)
                                sortOrder = ctx
                        })
                        return this.mapContext.getWorkspacesPrivate(sortOrder)
                    }.bind(this),
                    itemOptionsBuilder: function (ws) {
                        return workspaceAdditionalOptionsBuilder(ws, { contextKeySuffix: 'privateMaps-layers'})
                    },
                    contextStorage: this.contextStorage,
                    contextStorageKey: this.contextStorageKeyOrder + '-workspaces',
                    eventObject: this.mapContext,
                    eventNamePrefix: "ws",
                    draggable: true,
                    debug: this.debug,
                    reorderCb: function (updatedList, movedElfromIdx, movedEltoIdx) {
                        this.saveContext(updatedList.map( ws => ws.id))
                    }
                }
            ),
            public: new UICMapList(
                {
                    view: "mapsList",
                    id: "mapsPanel-publicMaps",
                    title: function () { return `Public maps (${this.list.length})`},
                    list: this.publicWorkspaces,
                    listBuilder: function () {
                        if (! this.mapContext.UIContext.get("showPublicMaps"))
                            return []
                        return this.mapContext.getWorkspacesPublic()
                    }.bind(this),
                    itemOptionsBuilder: function (ws) {
                        return workspaceAdditionalOptionsBuilder(ws, { contextKeySuffix: 'publicMaps-layers'})
                    },
                    eventObject: this.mapContext,
                    eventNamePrefix: "ws",
                    debug: this.debug
                }
            ),
            archive: null
        }
        let workspaceList = new UICollapseList(
            {
                contextStorage: this.contextStorage,
                contextStorageKey: this.contextStorageKeyCollapse,
                debug: this.debug,
                items: [
                    {   id: "ui-sidebar-list-myMaps",
                        content: this.mapLists.private
                    },
                    {
                        id: "ui-sidebar-list-publicMaps",
                        content: this.mapLists.public
                    }
                ]
            }
        )
        this.view = workspaceList
    }

    layersUIC(ws, contextKeySuffix) {
        const layers = ws.getNotDrawingLayers()

        if (! this.layerUICs[ws.id]) {
            this.layerUICs[ws.id] = new UICollapseList({
                contextStorage: this.contextStorage,
                contextStorageKey: `${this.contextStorageKeyCollapse}-${ws.id}-${contextKeySuffix}`,
                items: [
                    {   id: `ui-sidebar-mapslist-${ws.id}-collapse-layers`,
                        content: new UICMapList(
                            {
                                view: "layersList",
                                controlsView: "layerControls",
                                id: `mapsPanel-publicMaps-${ws.id}-layers`,
                                title: `Layers (${layers.length})`,
                                list: layers,
                                debug: this,
                                itemOptionsBuilder: function (l) {
                                    return {
                                        deletable: (ws.isMine() || ws.isWritable()) && layers.length > 1,
                                        download: ws.publicDownload || ws.isMine() || ws.shared,
                                        preview: l.getPreview()
                                    }
                                },
                                eventObject: this.mapContext,
                                eventNamePrefix: "layer"
                            }
                        )
                    }
                ]
            })
        } else {
            // close already initialized UIC to remove event handlers generally
            this.layerUICs[ws.id].close()
        }
        return this.layerUICs[ws.id]
    }

    // force list updates
    updatePrivateMaps() {
        this.mapLists.private.updateList()
    }

    updatePublicMaps() {
        this.mapLists.public.updateList()
    }

    open(container) {
        super.open(container)
        if (this.contextStorage)
            this.contextStorage.on("showPublicMaps", this.updatePublicMaps, this)
        this.mapContext.on("mh:wsCreated", this.updatePrivateMaps, this)
        this.mapContext.on("mh:wsDelete", this.updatePrivateMaps, this)
    }

    close(onCancel) {
        super.close(onCancel)
        this.mapContext.off("mh:wsCreated", this.updatePrivateMaps, this)
        this.mapContext.off("mh:wsDelete", this.updatePrivateMaps, this)
        if (this.contextStorage)
            this.contextStorage.off("showPublicMaps", this.updatePublicMaps, this)
    }
}
